import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FEE_RATE_BASE_PATH } from '../../../../../../../../../features/fees/fee-rate/fee-rate-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'fee-rate-list',
        label: 'Middle Money',
        to: FEE_RATE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
